import EnumBase from './Base';

export default function reportPbiTypeEnum(){
  return new EnumBase([
    { id: 'dashboard', name: 'Dashboard' },
    { id: 'report',    name: 'Relatório' }
  ]);
}
